import styled from 'styled-components';

import { Flex, Typography } from '@aircall/tractor';
import { StyledHeader } from '@components/Header/Header';
import { variable } from '@helpers/style.helpers';

import { LeanHeaderProps } from '.';

const LogoWrapper = styled(Flex)`
  width: 100%;
  align-items: center;
  padding-left: ${variable.space.m}px;

  > img {
    width: ${variable.space.m}px;
  }
`;

export function LeanHeader({
  logoUrl,
  altText,
  companyName,
  'data-test': dataTest,
}: LeanHeaderProps) {
  return (
    <StyledHeader
      position='fixed'
      zIndex={1}
      top={0}
      width='100%'
      height={64}
      data-test={`${dataTest}-app-header`}
    >
      <LogoWrapper>
        <img src={logoUrl} alt={`${altText} logo`} data-test={`${dataTest}-app-logo`} />
        <Typography variant='displayS' fontWeight={700} ml='xxs' data-test={`${dataTest}-app-name`}>
          {companyName}
        </Typography>
      </LogoWrapper>
    </StyledHeader>
  );
}
